import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import {
  Archive as ArchiveIcon,
  FileText as FileIcon,
  MapPin as MapPinIcon,
  BarChart2 as BarChart2Icon,
  Layout as LayoutIcon
} from 'react-feather';
import { Section } from './types';

const sections: Section[] = [
  {
    key: 'common',
    items: [
      {
        title: 'Аналитика',
        icon: LayoutIcon,
        href: '/app/dashboard'
      },
      {
        title: 'Отчеты',
        icon: BarChart2Icon,
        items: [
          {
            title: 'Журнал учета РАО',
            href: '/app/rao-log'
          },
          {
            title: 'Журнал учета ЯДМ',
            href: '/app/rao-density'
          },
          {
            title: 'Отчет по ООБ',
            href: '/app/oob'
          },
          {
            title: 'Годовой отчет',
            href: '/app/annual'
          },
          {
            title: 'Оперативный отчет',
            href: '/app/operative'
          },
          {
            title: 'СНК РАО',
            href: '/app/inventory'
          },
          {
            title: 'Транспортирование РАО',
            href: '/app/transportation'
          },
        ]
      }
    ]
  },
  {
    subheader: 'Объекты',
    key: 'objects',
    items: [
      {
        title: 'Паспорта РАО',
        icon: FileIcon,
        href: '/app/passports'
      },
      {
        title: 'Акты приема-передачи',
        icon: AttachFileOutlinedIcon,
        href: '/app/delivery-reports'
      },
      {
        title: 'Схема размещения РАО',
        icon: MapPinIcon,
        href: '/app/repositories'
      },
      {
        title: 'Архив документов',
        icon: ArchiveIcon,
        href: '/app/archive'
      }
    ]
  }
];

export default sections;
